export default "/institutions/99pay.svg";